import logo from './logo.svg';
import './App.css';
import MemecoinGenerator from './MemecoinGenerator';

function App() {
  return (
    <div className="App">
     <MemecoinGenerator></MemecoinGenerator>
    </div>
  );
}

export default App;
